import { List, Toast } from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PsContext from "../../context";
import {
  COURSE_TYPE_SORT_ORDER,
  customSorting,
  jsonToQuery,
  upperCase,
} from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";

import DayOrderDates from "./dayOrderDates";

const MarkedAttendanceReport = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [courseTypes, setCourseTypes] = useState([]);

  const params = useParams();

  useEffect(() => {
    loadCourseTypes();
  }, []);

  const loadCourseTypes = () => {
    context.setLoader(true);
    axios.get(ServiceUrl.MOB.TIMETABLE_COURSE_TYPES).then((res) => {
      if (res["data"].status == "1") {
        let m = customSorting(
          res["data"].data,
          COURSE_TYPE_SORT_ORDER,
          "coursetype"
        );
        setCourseTypes(m);
      } else {
        Toast.show({ content: res["data"].message || "Error" });
      }

      context.setLoader(false);
    });
  };

  const linkClick = (path, item) => {
    navigate(path + "?" + jsonToQuery(item));
  };

  const getTitle = () => {
    return params?.type
      ? `${upperCase(params.type)} Attendance Marked Report`
      : "Attendance Marked Report";
  };

  const bakcLinkClick = () => {
    let path = params?.type ? "/staff/app/my-att-report" : "/staff/app";
    navigate(path);
  };

  return (
    <>
      <Header
        hideLogoText={true}
        onBack={(e) => bakcLinkClick()}
        title={getTitle()}
        backAction={true}
        rightActions={[]}
      />
      <div className="py-md-3">
        <div className="container-sm">
          <section className="pt-0 pb-0">
            {!params.type && (
              <div data-aos="zoom-in">
                <List>
                  {courseTypes.map((item) => (
                    <List.Item
                      className="ps-3"
                      onClick={(e) =>
                        linkClick(
                          `/staff/app/my-att-report/${item.course_level_name}`,
                          item
                        )
                      }
                    >
                      {upperCase(item.course_level_name)}
                    </List.Item>
                  ))}
                </List>
              </div>
            )}

            {params.type && <DayOrderDates courseType={params.type} />}
          </section>
        </div>
      </div>
    </>
  );
};
export default MarkedAttendanceReport;
